// @flow
import { Button, Col, Row } from "antd";
import { Checkbox } from "views/components/Checkbox";
import { CloseOutlined, DownOutlined } from "@ant-design/icons";
import {
	CloseSection,
	FlexCol,
	PhoneSection,
	WhatsappSection,
	Wrapper,
} from "./Popup.styles";
import { DropDown } from "views/components/common/Form";
import { ErrorMessage } from "views/components/Message";
import { FlatButton } from "views/components/FlatButton";
import { Form, Input } from "views/components/common/Form";
import { Link } from "react-router-dom";
import { Modal } from "views/components/Modal";
import { ReactSVG } from "react-svg";
import { Select } from "../Toggle";
import { Spacer } from "views/components/common/Spacer";
import { produce } from "immer";
import { useUpdateUserInfo } from "state/users/hooks";
import React, { useState } from "reactn";
import format, {
	formatPhoneWithoutCountryCode,
	validate,
	validatePhone,
	validateShortPhone,
} from "lib/rut";
import styled from "styled-components";
import theme, { getColor, getGradient, getSize } from "views/resources/theme";

import iconWhatsapp from "views/resources/icons/whatsapp.svg";

export const RutModal = ({
	visible,
	askForPhone,
	askForSsn,
	onClose,
	pickTicket,
	isOngoing,
	setModalState,
}) => {
	const [updateUser, loading, error, resolved] = useUpdateUserInfo();
	const handleSubmit = () => {
		const form = produce(inputs, (i) => {
			i.phone = i.countryCode + i.phone;
		});
		setModalState("force");
		updateUser(form);
		pickTicket();
	};

	const countryCodes = ["+56", "+54", "+51", "+58", "+57"];
	const [inputs, setInputs] = useState({
		rut: null,
		dni: null,
		countryCode: countryCodes[0],
		type: "rut",
		whatsapp: null,
		phone: null,
	});
	const handleChange = ({ target: { name, value } }) =>
		setInputs((i) => ({ ...i, [name]: value }));

	const whatsappOnly = !askForSsn && askForPhone;

	return (
		<Modal visible={visible}>
			<CloseSection>
				<Button
					onClick={onClose}
					type="dashed"
					shape="circle"
					icon={
						<CloseOutlined
							style={{ fontSize: "26px", color: "#aaa" }}
						/>
					}
				></Button>
			</CloseSection>
			<Wrapper>
				<Form>
					<h3>
						{whatsappOnly
							? "Esta oficina necesita más información para permitirte sacar un ticket."
							: "Esta oficina necesita más información para permitirte sacar un ticket."}
					</h3>
					<ErrorMessage error={error} />
					<Select
						hidden={!askForSsn}
						name="type"
						value={inputs.type}
						opts={[
							{ htmlValue: "dni", label: "DNI" },
							{ htmlValue: "rut", label: "RUT" },
						]}
						onChange={handleChange}
					/>
					{inputs.type === "rut" && (
						<Input
							validator={(v) => (v === null ? true : validate(v))}
							hidden={!askForSsn}
							label="RUT"
							errorMessage="RUT inválido"
							name="rut"
							value={inputs.rut}
							onChange={handleChange}
							postInput={format}
						/>
					)}
					{inputs.type === "dni" && (
						<Input
							hidden={!askForSsn}
							validator={() => Boolean(inputs.dni)}
							label="DNI"
							errorMessage="DNI inválido"
							name="dni"
							value={inputs.dni}
							onChange={handleChange}
						/>
					)}
					<Spacer rows={1} />

					{/* {askForPhone && (
						<WhatsappSection>
							{!whatsappOnly && (
								<h3>
									¿Quieres recibir notificaciones por
									Whatsapp?
								</h3>
							)}
							<div className="whatsappBox">
								<Row align="bottom">
									<Col span={21}>
										<Checkbox
											hidden={!askForPhone}
											name="whatsapp"
											value={inputs.whatsapp}
											checked={inputs.whatsapp}
											onChange={handleChange}
											label="Deseo seguir mi ticket de atención por Whatsapp"
										/>
									</Col>
									<Col span={3}>
										<ReactSVG src={iconWhatsapp} />
									</Col>
								</Row>
							</div>
							<p>
								Puedes desactivar las notificaciones después
								desde tu <Link to="/profile">Perfil</Link>
							</p>
						</WhatsappSection>
					)} */}

					{/* <Spacer rows={1} />

					<PhoneSection>
						{inputs.whatsapp && (
							<div>
								<h4>Número de Teléfono</h4>
								<Row align="bottom">
									<Col span={6}>
										<DropDown
											type={"button"}
											items={countryCodes}
											name="countryCode"
											title={inputs.countryCode}
											onClick={handleChange}
										>
											<Button>
												Button <DownOutlined />
											</Button>
										</DropDown>
									</Col>
									<Col span={18}>
										<Input
											validator={validateShortPhone}
											label="900000000"
											errorMessage="Debes ingresar un número válido"
											name="phone"
											value={inputs.phone}
											onChange={handleChange}
											postInput={
												formatPhoneWithoutCountryCode
											}
										/>
									</Col>
								</Row>
							</div>
						)}
					</PhoneSection> */}

					<Spacer rows={1} />
					<FlatButton
						disabled={
							loading ||
							isOngoing ||
							(askForSsn &&
								inputs.type === "rut" &&
								!validate(inputs[inputs.type]))
						}
						loading={loading || isOngoing}
						text={
							askForPhone && inputs.whatsapp
								? "Guardar cambios y Sacar ticket"
								: "Sacar ticket"
						}
						onClick={handleSubmit}
					/>
					<Spacer rows={1} />
				</Form>
			</Wrapper>
		</Modal>
	);
};
